import { render, staticRenderFns } from "./payment-management.vue?vue&type=template&id=becc31a2&scoped=true"
import script from "./payment-management.vue?vue&type=script&lang=js"
export * from "./payment-management.vue?vue&type=script&lang=js"
import style0 from "./payment-management.vue?vue&type=style&index=0&id=becc31a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becc31a2",
  null
  
)

export default component.exports